import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

interface IProps {
  value: string;
  size?: number;
}

export const QrCodeImage: React.FC<IProps> = ({ value, size = 180 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && value) {
      QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 });
    }
  }, [value, size]);

  return <canvas ref={canvasRef} />;
};
